// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Explicit persistence with fallback. indexedDB is the default and survives browser
// restarts on most platforms; localStorage fallback covers Safari private mode /
// embedded webviews where IndexedDB may be blocked or evicted.
setPersistence(auth, indexedDBLocalPersistence).catch(() => {
  return setPersistence(auth, browserLocalPersistence).catch((err) => {
    console.warn('Could not set auth persistence:', err?.code || err);
  });
});
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app); // Default region (us-central1)
const functionsEurope = getFunctions(app, 'europe-west1'); // Europe region for cleanup functions
const googleProvider = new GoogleAuthProvider();

// Optionally connect to emulator
// connectFunctionsEmulator(functions, "localhost", 5001);

export { auth, db, storage, functions, functionsEurope, googleProvider };